import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SeoRoutingModule } from './seo-routing.module';
import { AppSeoLocationPageComponent } from './app-seo-location-page/app-seo-location-page.component';
import { SeoLocationPageResolve } from '../../core/services/seo-location-page.resolve';
import { CharterBuyflowVesselsModule } from '../public/charter-buyflow/charter-buyflow-vessels/charter-buyflow-vessels.module';
import { CharterBuyflowVesselsResolve } from '../public/charter-buyflow/charter-buyflow-vessels/charter-buyflow-vessels.resolve';
import { PostRendererModule } from '../post-renderer/post-renderer.module';

@NgModule({
  declarations: [AppSeoLocationPageComponent],
  imports: [
    CommonModule,
    SeoRoutingModule,
    CharterBuyflowVesselsModule,
    PostRendererModule,
  ],
  providers: [SeoLocationPageResolve, CharterBuyflowVesselsResolve],
})
export class SeoModule {}
